import Immutable, { Map } from 'immutable'

const initialState = new Map({
  token: localStorage.getItem('token') || '',
  error: new Map({}),
  success: new Map({}),
  org: null,
  registrationUrl: null,
  sessionLanguage: null,
  expiredCampaign: false
})

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'auth_token':
      localStorage.setItem('token', action.token)
      return state.set('token', action.token)
    case 'auth_error':
      return state.set('error', Immutable.fromJS(action.error))
    case 'auth_success':
      return state.set('success', Immutable.fromJS(action.message))
    case 'auth_message_clear':
      return state.set('error', new Map({})).set('success', new Map({}))
    case 'auth_org':
      return state.set('org', action.id)
    case 'auth_token_registration':
      return state.set('registrationUrl', action.registrationUrl)
    case 'set_session_language':
      return state.set('sessionLanguage', action.sessionLanguage)
    case 'expiredCampaign':
      return state.set('expiredCampaign', action.expiredCampaign)
    default:
      return state
  }
}
export default authReducer
export { authReducer }
